module.exports = "//static.hsappstatic.net/connect-dot-com-ui-components/static-1.1351/images/logo/connect-dot-com-beta-logo.svg"